import * as yup from 'yup';
import { ServiceRequestPageFormData } from './ServiceRequestPageFormData';

export function createServiceRequestFormSchema(mileage: number): yup.SchemaOf<ServiceRequestPageFormData> {
  return yup.object({
    mileage: yup.number().label('Mileage').min(mileage).max(9999999999).required(),
    serviceTypeName: yup.string().required(),
    serviceCommentary: yup.string().label('Service').max(250).notRequired(),
  });
}
